import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

export const POSTHOG_WORKSPACE_PROPERTY = 'workspaceId';
export const POSTHOG_WORKSPACE_GROUP_TYPE = 'workspaceId';

/**
 * Keeps the active workspace on every PostHog event, as a super property and a
 * group association.
 *
 * Matches the `workspaceId` property and `groups: { workspaceId }` the backend
 * sends, so dashboard and API events segment and aggregate by the same key.
 */
export const useSyncPostHogWorkspace = (
  workspaceId: string | undefined
): void => {
  const postHog = usePostHog();

  // Both persist across reloads, so an absent workspace must clear them.
  // `resetGroups` wipes every group type — workspace is the only one.
  useEffect(() => {
    if (workspaceId) {
      postHog.register({ [POSTHOG_WORKSPACE_PROPERTY]: workspaceId });
      postHog.group(POSTHOG_WORKSPACE_GROUP_TYPE, workspaceId);
    } else {
      postHog.unregister(POSTHOG_WORKSPACE_PROPERTY);
      postHog.resetGroups();
    }
  }, [postHog, workspaceId]);
};
